import {
  DEVICE_ALL,
  DEVICE_HIBERNATING,
  DEVICE_OFFLINE,
  DEVICE_ONLINE,
} from "constant/device-status";
import get from "lodash/get";
import { defaultArray, defaultObject } from "redux-store/selectors";
import { createSelector } from "reselect";

function accountStatsSelector(state) {
  return get(state, "pages.accountStats", defaultObject);
}

function accountEventsSelector(state) {
  return get(accountStatsSelector(state), "events_24h", null);
}

function deviceAverageUptimeSelector(state) {
  return get(accountStatsSelector(state), "device_average_uptime", null);
}

function incidentsSelector(state) {
  return get(accountStatsSelector(state), "incidents", defaultArray);
}

function playerVersionStatsSelector(state) {
  return get(accountStatsSelector(state), "player_stats", defaultArray);
}

function strategyStatsSelector(state) {
  return get(accountStatsSelector(state), "strategy_stats", defaultArray);
}

function uptimesSelector(state) {
  return get(accountStatsSelector(state), "uptimes_by_network", defaultObject);
}

function _convertStatusToCode(accountStats) {
  const statusCodes = [
    DEVICE_ALL,
    DEVICE_HIBERNATING,
    DEVICE_OFFLINE,
    DEVICE_ONLINE,
  ];

  return statusCodes.reduce((acc, key) => {
    acc[key.code] = accountStats[`device_${key.id}`] || 0;
    return acc;
  }, {});
}

const statusCountsSelector = createSelector(
  accountStatsSelector,
  _convertStatusToCode,
);

export {
  _convertStatusToCode,
  accountEventsSelector,
  accountStatsSelector,
  deviceAverageUptimeSelector,
  incidentsSelector,
  playerVersionStatsSelector,
  statusCountsSelector,
  strategyStatsSelector,
  uptimesSelector,
};
